import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { useGate } from 'effector-react';

import { Authentication } from '@/services';
import { AuthProviderGate } from '@/store';

export type AuthProviderProps = {
  authProvider: Authentication;
  fallback?: JSX.Element;
  children: ReactNode;
};

export type AuthContext = {
  fallback?: JSX.Element;
};

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext) as Required<AuthContext>;

export const AuthProvider = ({ authProvider, fallback, children }: AuthProviderProps) => {
  useGate(AuthProviderGate, authProvider);

  const value = useMemo(
    () => ({
      fallback,
    }),
    [fallback],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
